export const SET_PREMIUM = 'SET_PREMIUM';

export function setPremium(value) {
    return {
        type: SET_PREMIUM,
        payload: value,
    };
}
